export default __webpack_public_path__ + "static/media/fad-roundswitch-off.dd0056de.svg";